
import { Component, Inject, Vue } from 'vue-property-decorator';
import GeneralScaffold from '@/components/GeneralScaffold.vue';
import FormModelDisplay from '@/components/FormModelDisplay.vue';
import LibraryItemRepository from '@/repositories/libraryitem/LibraryItemRepository';
import EmbeddedForm from '@/util/form/EmbeddedForm';
import LibraryItemTranslationRepository from '@/repositories/libraryitem/LibraryItemTranslationRepository';

@Component({
    components: {
        GeneralScaffold,
        FormModelDisplay,
    },
})
export default class LibraryItemFormScreen extends Vue {
    @Inject()
    private readonly libraryItemRepository!: LibraryItemRepository;

    @Inject()
    private readonly libraryItemTranslationRepository!: LibraryItemTranslationRepository;

    public get embeds(): EmbeddedForm[] {
        return [
            {
                relationship: 'translations',
                parentRefKey: 'libraryItemId',
                i18nGroup: 'library-item-translation',
                entityRepository: this.libraryItemTranslationRepository,
                columns: ['lang', 'subject'],
            },
        ];
    }
}
